import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-foreground-200">
      <div className="w-full px-6 md:px-10 py-14 md:py-18">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer group">
                <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-gamepad-line text-background-50 text-base"></i>
                </div>
                <span className="font-heading font-bold text-xl text-white whitespace-nowrap">
                  木瓜玩
                </span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed mt-3">
                专注海外游戏发行、买量投放与用户增长的一站式营销平台，助力游戏出海企业快速拓展全球市场。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-white mb-4 text-sm">
                <a href="#services-footer" className="cursor-pointer">核心服务</a>
              </h4>
              <ul className="space-y-2.5">
                <li><a href="/articles?category=advertising" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">精准广告投放</a></li>
                <li><a href="/articles?category=analytics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">数据分析归因</a></li>
                <li><a href="/articles?category=creative" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">创意素材制作</a></li>
                <li><a href="/articles?category=market-insight" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">海外市场洞察</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-white mb-4 text-sm">
                <a href="/articles" className="cursor-pointer">行业洞察</a>
              </h4>
              <ul className="space-y-2.5">
                <li><a href="/articles?category=advertising" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">广告投放攻略</a></li>
                <li><a href="/articles?category=case-study" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">客户成功案例</a></li>
                <li><a href="/articles?category=analytics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">数据分析方法论</a></li>
                <li><a href="/articles?category=creative" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">创意设计趋势</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-white mb-4 text-sm">
                <Link to="/about" className="cursor-pointer">关于我们</Link>
              </h4>
              <ul className="space-y-2.5">
                <li><a href="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">品牌介绍</a></li>
                <li><a href="/about#contact" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a></li>
                <li><a href="/about#faq" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a></li>
              </ul>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm text-foreground-200"></i>
                </a>
                <a href="#" className="w-8 h-8 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm text-foreground-200"></i>
                </a>
                <a href="#" className="w-8 h-8 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="LinkedIn">
                  <i className="ri-linkedin-line text-sm text-foreground-200"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} 木瓜玩 版权所有 | 专注海外游戏发行与用户增长
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">Cookie政策</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}